module.exports = __webpack_public_path__ + "media/images/flags/1x1/abw-82f8ec889263537ee5362e3d8955d0a6.svg";